/**
 * @fileoverview POST handler for the "/engagement/segments/:segment_id/export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentsSegmentIdExportCacheKeys } from "./constants";
import type { PostEngagementSegmentsExportProps } from "./types";

export const postEngagementSegmentsExport = reactQueryMutationAdapter(
  engagementSegmentsSegmentIdExportCacheKeys,
  (props: PostEngagementSegmentsExportProps): Promise<{}> => {
    return fetch(
      `/engagement/segments/${props.segmentId}/export`,
      "POST",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
